export { ComponentWidgetRenderer } from './ComponentWidgetRenderer'
export type { ComponentWidgetRendererProps } from './ComponentWidgetRenderer'
